import Navbar from "../design/high-level/navbar/Navbar";
import Box from "../design/components-dev/BoxExtended";
import { useXNGSelector } from "../context/store";

export function NavLayout(props: { children: React.ReactNode }) {
  const maintenanceModeActive = useXNGSelector((state) => state.featureFlags.flags["MaintenanceModeWarningActive"]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
      }}
      >
        {maintenanceModeActive && (
          <Box
            sx={{
              color: "white",
              backgroundColor: "orange",
              padding: "0.5rem",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Box>
              X Logs will be unavailable due to maintenance starting Friday, October 10th at 5:00 PM (CT) until Monday, October 13th at 7:00 AM (CT).
            </Box>
          </Box>
        )}
      <Navbar />

      {props.children}
    </Box>
  );
}
